import { createSlice } from '@reduxjs/toolkit';
import { DEFAULT_ASSESSMENT_LIMIT_OFFSET, SUCCESS_STATUS } from '../constants';
import { request } from '../service/api';
import { constructEndpoint } from '../utils';

export const appSlice = createSlice({
  name: 'app',
  initialState: {
    loading: false,
    errorMessage: '',
    deleteStatus:'',
    accessError: null,
    deleteAdminStatus: false,
    deleteAdminChildStatus: false
  },
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.errorMessage = action.payload
    },
    clearError: (state) => {
      state.errorMessage = ''
    },
    setDeleteStatus: (state, action) => {
      state.deleteStatus = action.payload
    },
    setAccessError: (state, action) => {
      state.accessError = action.payload;
    },
    setDeleteAdminStatus: (state, action) => {
      state.deleteAdminStatus = action.payload;
    },
    setDeleteAdminChildStatus: (state, action) => {
      state.deleteAdminChildStatus = action.payload;
    }
  },
});

export const { setLoading, setError, clearError, setDeleteStatus, setAccessError, setDeleteAdminStatus, setDeleteAdminChildStatus } = appSlice.actions;

export const deleteAsync = (endpoint, ...params) => async dispatch => {
  dispatch(setDeleteStatus(''))
  try {
    dispatch(setLoading(true));
    const response = await request(constructEndpoint(endpoint, ...params), {
      method: 'DELETE'
    })
    dispatch(setDeleteStatus(response))
  }
  catch (error) {
    const obj = { ...error }
    if(obj?.response?.status === 405){
      dispatch(setAccessError(obj.errorMessage))
    }else{
      /* If there are error, dispatch setError action */
      dispatch(setDeleteStatus(obj))
      dispatch(setError(obj.errorMessage))
    }
  }
  finally {
    dispatch(setLoading(false));
  }
}

export const deleteParentChildAsync = (payload, deleteURL, patientAssessmentAsync, patientAssessmentHistoryAsync, finalArrValue) => async (dispatch) => {
  
  try {
    dispatch(setLoading(true));
    const data = await request(deleteURL, {
      method: "DELETE",
      body: JSON.stringify(payload),
    });
    if (data && data.status === SUCCESS_STATUS) {      
      if(deleteURL==='/patient/initial/assessment'){
        dispatch(patientAssessmentAsync(payload?.patientId, DEFAULT_ASSESSMENT_LIMIT_OFFSET))
        dispatch(setDeleteAdminStatus(true))
      }
      if(deleteURL==='/patient/initial/reeval/assessment'){
        dispatch(patientAssessmentHistoryAsync(payload?.patientId, finalArrValue))
        dispatch(setDeleteAdminChildStatus(true))
      }
    }
  } catch (error) {
    const obj = { ...error }
    if(obj?.response?.status === 405){
      dispatch(setAccessError(obj.errorMessage))
    }else{
      /* If there are error, dispatch setError action */
      dispatch(setDeleteStatus(obj))
      dispatch(setError(obj.errorMessage))
    }
  }
  finally {
    dispatch(setLoading(false));
  }
};

export default appSlice.reducer;
